import React from "react";
import { Link } from "react-router-dom";

const Privacy = () => {
  return (
    <div>
      <nav className="navbar navbar-default navbar-fixed-top">
        <div className="container">
          <div className="navbar-header">
            <Link className="navbar-brand" to="/">
              By The App
            </Link>
          </div>
        </div>
      </nav>

      <main className="privacy-page">
        <div className="container">
          <div className="privacy-page-inner">
            <h1>Privacy Policy</h1>
            <p className="privacy-effective">Effective Date: January 01, 2026</p>

            <p>
              At ByTheApp, we value your privacy. This Privacy Policy explains how we
              collect, use, and protect your information when you interact with our
              customer service phone lines and SMS messaging services.
            </p>

            <div className="privacy-notice" role="note">
              <p>
                ByTheApp AI protects your privacy. No mobile information or SMS opt-in
                data will be shared with third parties or affiliates for marketing or
                promotional purposes. All the above categories exclude text messaging
                originator opt-in data and consent; this information will not be shared
                with any third parties.
              </p>
            </div>

            <h2>1. Information Collection</h2>
            <p>We collect information directly from you when you:</p>
            <ul>
              <li>Contact our customer support team via phone.</li>
              <li>Opt-in to receive SMS notifications or updates.</li>
              <li>Provide your phone number through our website contact forms.</li>
            </ul>
            <p>
              The information collected may include your name, phone number, and any
              details provided during your support inquiry.
            </p>

            <h2>2. Use of Information</h2>
            <p>We use your phone number and personal information strictly to:</p>
            <ul>
              <li>Provide the customer support or services you requested.</li>
              <li>
                Send transaction-related notifications (e.g., order confirmations,
                appointment reminders).
              </li>
              <li>Respond to your inquiries via voice or text.</li>
            </ul>

            <h2>3. Sharing of Information (The &quot;Twilio Compliance&quot; Clause)</h2>
            <p>ByTheApp does not sell, rent, or lease its customer lists to third parties.</p>
            <p>
              We do not share mobile information or SMS opt-in data with third parties or
              affiliates for marketing or promotional purposes. Text messaging originator
              opt-in data and consent are excluded from all sharing categories and will not
              be shared with any third parties.
            </p>

            <h2>4. Text Messaging (SMS) Terms</h2>
            <p>If you opt-in to receive SMS from us:</p>
            <ul>
              <li>
                <strong>Opt-In:</strong> By providing your number and checking the consent
                box, you agree to receive recurring messages.
              </li>
              <li>
                <strong>Opt-Out:</strong> You can cancel the SMS service at any time. Just
                text &quot;STOP&quot; to 18772417545. After you send the SMS message
                &quot;STOP&quot; to us, we will send you an SMS message to confirm that you
                have been unsubscribed.
              </li>
              <li>
                <strong>Help:</strong> If you are experiencing issues with the messaging
                program you can reply with the keyword HELP for more assistance.
              </li>
              <li>
                <strong>Costs:</strong> As always, message and data rates may apply for any
                messages sent to you from us and to us from you. Message frequency varies.
              </li>
            </ul>

            <h2>5. Data Security</h2>
            <p>
              We implement a variety of security measures to maintain the safety of your
              personal information. Your data is stored behind secured networks and is
              only accessible by a limited number of persons who have special access rights
              to such systems.
            </p>

            <h2>6. Contact Us</h2>
            <p>
              If there are any questions regarding this privacy policy, you may contact us
              using the information below:
            </p>
            <p>
              BY THE APP
              <br />
              <a href="https://www.bytheapp.com">www.bytheapp.com</a>
              <br />
              <a href="mailto:contact@bytheapp.com">contact@bytheapp.com</a>
            </p>

            <p className="privacy-back">
              <Link to="/">← Back to home</Link>
            </p>
          </div>
        </div>
      </main>

      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2025 ByTheApp. All rights reserved.{" "}
            <a href="mailto:info@bytheapp.com">info@bytheapp.com</a>
            {" · "}
            <Link to="/privacy">Privacy Policy</Link>
            {" · "}
            <Link to="/terms">Terms</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
